export default __webpack_public_path__ + "static/media/wire.46ddf028.png";